/* eslint-disable */
// This is auto generated code, do not edit directly
// @ts-nocheck

import * as z from 'zod';
import * as types from './types';

type Properties<T> = Required<{
	[K in keyof T]: z.ZodType<T[K]>;
}>;

type definedNonNullAny = {};

export const isDefinedNonNullAny = (v: any): v is definedNonNullAny =>
	v !== undefined && v !== null;

export const definedNonNullAnySchema = z
	.any()
	.refine(v => isDefinedNonNullAny(v));

export const AffiliationDirectionSchema = z.enum(types.AffiliationDirection);

export const AffiliationGroupSortSchema = z.enum(types.AffiliationGroupSort);

export const AuthenticationChallengeSchema = z.enum(
	types.AuthenticationChallenge
);

export const CsvDelimiterSchema = z.enum(types.CsvDelimiter);

export const DcrDisplayStatusSchema = z.enum(types.DcrDisplayStatus);

export const DcrEntityTypeSchema = z.enum(types.DcrEntityType);

export const DcrFieldNameSchema = z.enum(types.DcrFieldName);

export const DcrFieldResultStatusSchema = z.enum(types.DcrFieldResultStatus);

export const DcrResultStatusSchema = z.enum(types.DcrResultStatus);

export const DcrStatusSchema = z.enum(types.DcrStatus);

export const DcrTypeSchema = z.enum(types.DcrType);

export const DepartmentSchema = z.enum(types.Department);

export const EntityTypeSchema = z.enum(types.EntityType);

export const ReferenceTypeSchema = z.enum(types.ReferenceType);

export const RoleSchema = z.enum(types.Role);

export function AcademicStatusSchema(): z.ZodObject<
	Properties<types.AcademicStatus>
> {
	return z.object({
		__typename: z.literal('AcademicStatus').optional(),
		code: z.string(),
		localizedName: z.string().nullish(),
		name: z.string()
	});
}

export function AddressSchema(): z.ZodObject<Properties<types.Address>> {
	return z.object({
		__typename: z.literal('Address').optional(),
		buildingIdentifier_V: z.string().nullish(),
		businessCda_V: z.boolean().nullish(),
		cbsa_V: z.string().nullish(),
		cityCda_V: z.string().nullish(),
		cityIntl_V: z.string().nullish(),
		countryCda_V: z.string().nullish(),
		dpvConfirmedIndicator_V: z.string().nullish(),
		fax1_V: z.string().nullish(),
		faxCda_V: z.string().nullish(),
		hospitalCampus: z.lazy(() => HcoResourceNotFoundSchema().nullish()),
		hospitalCampusName_V: z.string().nullish(),
		hospitalCampusVeevaid_V: z.string().nullish(),
		latitudeCda_V: z.number().nullish(),
		longitudeCda_V: z.number().nullish(),
		phone1_V: z.string().nullish(),
		phone2_V: z.string().nullish(),
		phoneCda_V: z.string().nullish(),
		postalCodeCda_V: z.string().nullish(),
		postalCodeFullUs_V: z.string().nullish(),
		postalCodeIntl_V: z.string().nullish(),
		postalCodePrimary_V: z.string().nullish(),
		primaryCda_V: z.boolean().nullish(),
		stateCda_V: z.string().nullish(),
		statusCda_V: z.string().nullish(),
		statusCda_VId: z.string().nullish(),
		streetAddress1Cda_V: z.string().nullish(),
		streetAddress1Intl_V: z.string().nullish(),
		streetAddress2Cda_V: z.string().nullish(),
		streetAddress2Intl_V: z.string().nullish(),
		subAdministrativeArea_V: z.string().nullish(),
		subStateAdminUnit_V: z.string().nullish(),
		vid_V: z.string()
	});
}

export function AutocompleteInputSchema(): z.ZodObject<
	Properties<types.AutocompleteInput>
> {
	return z.object({
		searchString: z.string(),
		size: z.number().int().default(6)
	});
}

export function BadRequestSchema(): z.ZodObject<Properties<types.BadRequest>> {
	return z.object({
		__typename: z.literal('BadRequest').optional(),
		errors: z.array(z.string()),
		message: z.string()
	});
}

export function ClearRecentProfileStatusSchema(): z.ZodObject<
	Properties<types.ClearRecentProfileStatus>
> {
	return z.object({
		__typename: z.literal('ClearRecentProfileStatus').optional(),
		entityTypes: z.array(EntityTypeSchema)
	});
}

export function ClearRecentSearchStatusSchema(): z.ZodObject<
	Properties<types.ClearRecentSearchStatus>
> {
	return z.object({
		__typename: z.literal('ClearRecentSearchStatus').optional(),
		entityTypes: z.array(EntityTypeSchema)
	});
}

export function CountRangeSchema(): z.ZodObject<Properties<types.CountRange>> {
	return z.object({
		__typename: z.literal('CountRange').optional(),
		code: z.string(),
		localizedName: z.string().nullish(),
		name: z.string()
	});
}

export function CountrySchema(): z.ZodObject<Properties<types.Country>> {
	return z.object({
		__typename: z.literal('Country').optional(),
		count: z.number().int(),
		id: z.string(),
		name: z.string(),
		sortOrder: z.number().int().nullish(),
		states: z.array(z.lazy(() => StateSchema()))
	});
}

export function DcrSchema(): z.ZodObject<Properties<types.Dcr>> {
	return z.object({
		__typename: z.literal('DCR').optional(),
		attachments: z.array(z.lazy(() => DcrAttachmentSchema())),
		completedAt: z.string().datetime().nullish(),
		country: z.lazy(() => CountrySchema().nullish()),
		createdAt: z.string().datetime().nullish(),
		currentEntity: z.lazy(() => HcphcoSchema().nullish()),
		displayStatus: DcrDisplayStatusSchema,
		entityData: z.string(),
		entityType: DcrEntityTypeSchema,
		fieldResults: z.array(z.lazy(() => DcrFieldResultSchema())).nullish(),
		id: z.string().uuid(),
		networkId: z.string().nullish(),
		note: z.string().nullish(),
		resolutionNotes: z.array(z.lazy(() => DcrResolutionNoteSchema())).nullish(),
		result: DcrResultStatusSchema.nullish(),
		status: DcrStatusSchema,
		type: DcrTypeSchema,
		updatedAt: z.string().datetime().nullish()
	});
}

export function DcrAddressInputSchema(): z.ZodObject<
	Properties<types.DcrAddressInput>
> {
	return z.object({
		cbsa_VId: z.string().nullish(),
		cityCda_V: z.string().nullish(),
		countryCda_VId: z.string().nullish(),
		fax1_V: z.string().nullish(),
		faxCda_V: z.string().nullish(),
		phone1_V: z.string().nullish(),
		phoneCda_V: z.string().nullish(),
		postalCodeCda_V: z.string().nullish(),
		postalCodeFullUs_V: z.string().nullish(),
		primaryCda_V: z.boolean().nullish(),
		stateCda_VId: z.string().nullish(),
		statusCda_VId: z.string().nullish(),
		streetAddress1Cda_V: z.string().nullish(),
		streetAddress2Cda_V: z.string().nullish(),
		subAdministrativeArea_V: z.string().nullish(),
		subStateAdminUnit_V: z.string().nullish(),
		vid_V: z.string().nullish()
	});
}

export function DcrAttachmentSchema(): z.ZodObject<
	Properties<types.DcrAttachment>
> {
	return z.object({
		__typename: z.literal('DCRAttachment').optional(),
		fileContentType: z.string(),
		fileName: z.string(),
		fileSize: z.number().int(),
		id: z.string().uuid(),
		viewUrl: z.string()
	});
}

export function DcrBadRequestForbiddenSchema() {
	return z.union([BadRequestSchema(), DcrSchema(), ForbiddenSchema()]);
}

export function DcrCreateInputSchema(): z.ZodObject<
	Properties<types.DcrCreateInput>
> {
	return z.object({
		attachmentIds: z.array(z.string()).nullish(),
		entity: z.lazy(() => DcrOneOfEntityInputSchema()),
		note: z.string().nullish()
	});
}

export function DcrFieldResultSchema(): z.ZodObject<
	Properties<types.DcrFieldResult>
> {
	return z.object({
		__typename: z.literal('DCRFieldResult').optional(),
		field: z.string(),
		finalValue: z.string().nullish(),
		group: z.string(),
		previousValue: z.string().nullish(),
		requestedValue: z.string().nullish(),
		result: DcrFieldResultStatusSchema.nullish()
	});
}

export function DcrForbiddenResourceNotFoundSchema() {
	return z.union([DcrSchema(), ForbiddenSchema(), ResourceNotFoundSchema()]);
}

export function DcrhcoAutocompleteInputSchema(): z.ZodObject<
	Properties<types.DcrhcoAutocompleteInput>
> {
	return z.object({
		countryId: z.string(),
		searchString: z.string(),
		size: z.number().int().default(6)
	});
}

export function DcrhcoInputSchema(): z.ZodObject<
	Properties<types.DcrhcoInput>
> {
	return z.object({
		academicStatus_VId: z.string().nullish(),
		addresses_V: z.array(z.lazy(() => DcrAddressInputSchema())).nullish(),
		allSpecLocal_VId: z.array(z.string()).nullish(),
		businessType_VId: z.string().nullish(),
		countHcp_VId: z.string().nullish(),
		countPrescriber_VId: z.string().nullish(),
		emailCda_V: z.string().nullish(),
		faxCda_V: z.string().nullish(),
		hcoNameCda_V: z.string().nullish(),
		hcoOwnership_VId: z.string().nullish(),
		hcoTaxId_V: z.string().nullish(),
		hcoTypeCda_VId: z.string().nullish(),
		hcoTypeLocal_VId: z.string().nullish(),
		internationalName_V: z.string().nullish(),
		licenses_V: z.array(z.lazy(() => DcrLicenseInputSchema())).nullish(),
		nhidCda_V: z.string().nullish(),
		officePhoneCda_V: z.string().nullish(),
		parentHcos_V: z.array(z.lazy(() => DcrParentHcoInputSchema())).nullish(),
		primaryCountry_V: z.string().nullish(),
		spec1Local_VId: z.string().nullish(),
		spec2Local_VId: z.string().nullish(),
		statusCda_VId: z.string().nullish(),
		typeOfHierarchy_VId: z.string().nullish(),
		vid_V: z.string().nullish(),
		websiteCda_V: z.string().nullish()
	});
}

export function DcrhcpInputSchema(): z.ZodObject<
	Properties<types.DcrhcpInput>
> {
	return z.object({
		URL1_V: z.string().nullish(),
		addresses_V: z.array(z.lazy(() => DcrAddressInputSchema())).nullish(),
		allSpecLocal_VId: z.array(z.string()).nullish(),
		birthYear_V: z.number().int().nullish(),
		dataPrivacyOptOut_V: z.boolean().nullish(),
		degree1Cda_VId: z.string().nullish(),
		email2_V: z.string().nullish(),
		email3_V: z.string().nullish(),
		email4_V: z.string().nullish(),
		email5_V: z.string().nullish(),
		emailCda_V: z.string().nullish(),
		faxCda_V: z.string().nullish(),
		firstNameCda_V: z.string().nullish(),
		gender_VId: z.string().nullish(),
		gradSchool_V: z.string().nullish(),
		gradYear_V: z.number().int().nullish(),
		hcpStatus_VId: z.string().nullish(),
		hcpTaxId_V: z.string().nullish(),
		hcpTypeCda_VId: z.string().nullish(),
		hcpTypeLocal_VId: z.string().nullish(),
		inCurrentPecos_V: z.boolean().nullish(),
		internationalName_V: z.string().nullish(),
		languageCda_VId: z.string().nullish(),
		lastNameCda_V: z.string().nullish(),
		licenses_V: z.array(z.lazy(() => DcrLicenseInputSchema())).nullish(),
		middleNameCda_V: z.string().nullish(),
		nhid2_V: z.string().nullish(),
		nhidCda_V: z.string().nullish(),
		officePhoneCda_V: z.string().nullish(),
		parentHcos_V: z.array(z.lazy(() => DcrParentHcoInputSchema())).nullish(),
		phone2_V: z.string().nullish(),
		prefixCda_V: z.string().nullish(),
		prescriberCda_V: z.boolean().nullish(),
		primaryCountry_V: z.string().nullish(),
		spec1Cda_VId: z.string().nullish(),
		spec1Local_VId: z.string().nullish(),
		spec2Local_VId: z.string().nullish(),
		statusCda_VId: z.string().nullish(),
		suffixCda_V: z.string().nullish(),
		telehealth_V: z.boolean().nullish(),
		vid_V: z.string().nullish(),
		websiteCda_V: z.string().nullish(),
		yearOfBirthCda_V: z.number().int().nullish()
	});
}

export function DcrLicenseInputSchema(): z.ZodObject<
	Properties<types.DcrLicenseInput>
> {
	return z.object({
		expirationDate_V: z.string().nullish(),
		licenseNumber_V: z.string().nullish(),
		licenseStatus_VId: z.string().nullish(),
		typeValue_V: z.string().nullish(),
		vid_V: z.string().nullish()
	});
}

export function DcrOneOfEntityInputSchema(): z.ZodObject<
	Properties<types.DcrOneOfEntityInput>
> {
	return z.object({
		hco: z.lazy(() => DcrhcoInputSchema().nullish()),
		hcp: z.lazy(() => DcrhcpInputSchema().nullish())
	});
}

export function DcrParentHcoInputSchema(): z.ZodObject<
	Properties<types.DcrParentHcoInput>
> {
	return z.object({
		isPrimaryRelationship_V: z.boolean().nullish(),
		jobTitle_V: z.string().nullish(),
		parentHcoStatus_VId: z.string().nullish(),
		parentHcoVid_V: z.string().nullish(),
		relationshipType_VId: z.string().nullish(),
		role_V: z.string().nullish(),
		typeOfRelationship_VId: z.string().nullish(),
		vid_V: z.string().nullish()
	});
}

export function DcrResolutionNoteSchema(): z.ZodObject<
	Properties<types.DcrResolutionNote>
> {
	return z.object({
		__typename: z.literal('DCRResolutionNote').optional(),
		comment: z.string()
	});
}

export function DcrResultsSchema(): z.ZodObject<Properties<types.DcrResults>> {
	return z.object({
		__typename: z.literal('DCRResults').optional(),
		results: z.array(z.lazy(() => DcrSchema())),
		statusFacets: z.array(z.lazy(() => DcrStatusFacetSchema())),
		total: z.number().int()
	});
}

export function DcrResultsForbiddenBadRequestSchema() {
	return z.union([BadRequestSchema(), DcrResultsSchema(), ForbiddenSchema()]);
}

export function DcrStatusFacetSchema(): z.ZodObject<
	Properties<types.DcrStatusFacet>
> {
	return z.object({
		__typename: z.literal('DCRStatusFacet').optional(),
		count: z.number().int(),
		status: DcrDisplayStatusSchema
	});
}

export function DownloadOptionsSchema(): z.ZodObject<
	Properties<types.DownloadOptions>
> {
	return z.object({
		delimiter: CsvDelimiterSchema.default('COMMA')
	});
}

export function EitherSearchInputSchema(): z.ZodObject<
	Properties<types.EitherSearchInput>
> {
	return z.object({
		hco: z.lazy(() => HcoSearchAndFiltersInputSchema().nullish()),
		hcp: z.lazy(() => HcpSearchAndFiltersInputSchema().nullish())
	});
}

export function EmailValueSchema(): z.ZodObject<Properties<types.EmailValue>> {
	return z.object({
		__typename: z.literal('EmailValue').optional(),
		value: z.string()
	});
}

export function EmailValueForbiddenSchema() {
	return z.union([EmailValueSchema(), ForbiddenSchema()]);
}

export function EventCreatedSchema(): z.ZodObject<
	Properties<types.EventCreated>
> {
	return z.object({
		__typename: z.literal('EventCreated').optional(),
		messageId: z.string().nullish()
	});
}

export function EventCreatedBadRequestSchema() {
	return z.union([BadRequestSchema(), EventCreatedSchema()]);
}

export function ForbiddenSchema(): z.ZodObject<Properties<types.Forbidden>> {
	return z.object({
		__typename: z.literal('Forbidden').optional(),
		message: z.string()
	});
}

export function ForbiddenBadRequestSignInResultSchema() {
	return z.union([BadRequestSchema(), ForbiddenSchema(), SignInResultSchema()]);
}

export function ForbiddenServiceUnavailableInitiateAuthResultSchema() {
	return z.union([
		ForbiddenSchema(),
		InitiateAuthResultSchema(),
		ServiceUnavailableSchema()
	]);
}

export function HcoSchema(): z.ZodObject<Properties<types.Hco>> {
	return z.object({
		__typename: z.literal('HCO').optional(),
		academicStatus: z.lazy(() => AcademicStatusSchema().nullish()),
		activeHcpRollupCount: z.number().int(),
		addresses: z.array(z.lazy(() => AddressSchema())),
		affiliatedHcpSearch: z.lazy(() =>
			HcoAffiliatedHcpsResultsBadRequestSchema()
		),
		affiliationSearch: z.lazy(() => HcoAffiliationsResultsBadRequestSchema()),
		affiliations: z.lazy(() => HcoAffiliationsResultsSchema()),
		alternateName1_V: z.string().nullish(),
		businessType_V: z.string().nullish(),
		childhcos: z.array(z.lazy(() => ParentHcoSchema())),
		countHcp_V: z.string().nullish(),
		countryId: z.string().nullish(),
		displayName_V: z.string().nullish(),
		emailCda_V: z.string().nullish(),
		faxCda_V: z.string().nullish(),
		hcoHierarchyType: z.lazy(() => HcoHierarchyTypeSchema().nullish()),
		hcoNameCda_V: z.string().nullish(),
		hcoNameEnglish_V: z.string().nullish(),
		hcoNameIntl_V: z.string().nullish(),
		hcoNameShort_V: z.string().nullish(),
		hcoTaxId_V: z.string().nullish(),
		hcoType: z.lazy(() => HcoTypeSchema().nullish()),
		hcoTypeCda_V: z.string().nullish(),
		hcpCount: z.lazy(() => CountRangeSchema().nullish()),
		inactiveAffiliationCount: z.number().int(),
		inactiveHcpRollupCount: z.number().int(),
		internationalNameCda_V: z.string().nullish(),
		kaiser_V: z.boolean().nullish(),
		keyHcoNetwork_V: z.boolean().nullish(),
		licenses: z.array(z.lazy(() => LicenseSchema())),
		localHcoType: z.lazy(() => LocalHcoTypeSchema().nullish()),
		localSpecialties: z.array(z.lazy(() => LocalSpecialtySchema())),
		mainOrganization: z.lazy(() => HcoResourceNotFoundSchema().nullish()),
		majorClassOfTrade_V: z.string().nullish(),
		nhidCda_V: z.string().nullish(),
		officePhoneCda_V: z.string().nullish(),
		ownership: z.lazy(() => HcoOwnershipSchema().nullish()),
		parenthcos: z.array(z.lazy(() => ParentHcoSchema())),
		prescriberCount: z.lazy(() => CountRangeSchema().nullish()),
		primaryLocalSpecialty: z.lazy(() => LocalSpecialtySchema().nullish()),
		secondaryLocalSpecialty: z.lazy(() => LocalSpecialtySchema().nullish()),
		specialty1_V: z.string().nullish(),
		specialty2_V: z.string().nullish(),
		specialty3_V: z.string().nullish(),
		specialty4_V: z.string().nullish(),
		specialty5_V: z.string().nullish(),
		specialty6_V: z.string().nullish(),
		specialty7_V: z.string().nullish(),
		specialty8_V: z.string().nullish(),
		specialty9_V: z.string().nullish(),
		specialty10_V: z.string().nullish(),
		statusCda_V: z.string().nullish(),
		statusCda_VId: z.string().nullish(),
		topOrganization: z.lazy(() => HcoResourceNotFoundSchema().nullish()),
		vaDodAffiliated_V: z.boolean().nullish(),
		veevaid_V: z.string(),
		vid_V: z.string(),
		websiteCda_V: z.string().nullish()
	});
}

export function HcoAddressesArgsSchema(): z.ZodObject<
	Properties<types.HcoAddressesArgs>
> {
	return z.object({
		includeInactive: z.boolean().default(false)
	});
}

export function HcoAffiliatedHcpSearchArgsSchema(): z.ZodObject<
	Properties<types.HcoAffiliatedHcpSearchArgs>
> {
	return z.object({
		paginationInput: z.lazy(() => PaginationInputSchema()),
		payload: z.lazy(() => HcoAffiliatedHcpsSearchInputSchema())
	});
}

export function HcoAffiliationSearchArgsSchema(): z.ZodObject<
	Properties<types.HcoAffiliationSearchArgs>
> {
	return z.object({
		paginationInput: z.lazy(() => PaginationInputSchema()),
		payload: z.lazy(() => HcoAffiliationSearchInputSchema())
	});
}

export function HcoAffiliationsArgsSchema(): z.ZodObject<
	Properties<types.HcoAffiliationsArgs>
> {
	return z.object({
		paginationInput: z.lazy(() => PaginationInputSchema()),
		payload: z.lazy(() => HcoAffiliationsInputSchema())
	});
}

export function HcoInactiveAffiliationCountArgsSchema(): z.ZodObject<
	Properties<types.HcoInactiveAffiliationCountArgs>
> {
	return z.object({
		direction: AffiliationDirectionSchema
	});
}

export function HcoAffiliatedHcpsResultsSchema(): z.ZodObject<
	Properties<types.HcoAffiliatedHcpsResults>
> {
	return z.object({
		__typename: z.literal('HCOAffiliatedHcpsResults').optional(),
		hcpTypes: z.array(z.lazy(() => HcpTypeWithCountSchema())),
		inactiveCount: z.number().int(),
		paginationMetadata: z.lazy(() => PaginationMetadataSchema()),
		results: z.array(z.lazy(() => HcpSchema())),
		specialties: z.array(z.lazy(() => SpecialtyWithCountSchema()))
	});
}

export function HcoAffiliatedHcpsResultsBadRequestSchema() {
	return z.union([BadRequestSchema(), HcoAffiliatedHcpsResultsSchema()]);
}

export function HcoAffiliatedHcpsSearchInputSchema(): z.ZodObject<
	Properties<types.HcoAffiliatedHcpsSearchInput>
> {
	return z.object({
		hcpTypes: z.array(z.string()).nullish(),
		includeInactive: z.boolean().nullish(),
		nameSearch: z.string().nullish()
	});
}

export function HcoAffiliationSearchInputSchema(): z.ZodObject<
	Properties<types.HcoAffiliationSearchInput>
> {
	return z.object({
		directions: z.array(AffiliationDirectionSchema).nullish(),
		excludeRelationshipTypeIds: z.array(z.string()).nullish(),
		hcoTypeIds: z.array(z.string()).nullish(),
		includeInactive: z.boolean().nullish(),
		nameSearch: z.string().nullish(),
		relationshipTypeIds: z.array(z.string()).nullish(),
		sortBy: z.array(AffiliationGroupSortSchema).nullish()
	});
}

export function HcoAffiliationsInputSchema(): z.ZodObject<
	Properties<types.HcoAffiliationsInput>
> {
	return z.object({
		direction: AffiliationDirectionSchema,
		includeInactive: z.boolean().nullish()
	});
}

export function HcoAffiliationsResultsSchema(): z.ZodObject<
	Properties<types.HcoAffiliationsResults>
> {
	return z.object({
		__typename: z.literal('HCOAffiliationsResults').optional(),
		hcoTypes: z.array(z.lazy(() => HcoTypeWithCountSchema())),
		inactiveCount: z.number().int(),
		paginationMetadata: z.lazy(() => PaginationMetadataSchema()),
		results: z.array(z.lazy(() => ParentHcoSchema()))
	});
}

export function HcoAffiliationsResultsBadRequestSchema() {
	return z.union([BadRequestSchema(), HcoAffiliationsResultsSchema()]);
}

export function HcoAutocompleteResultSchema(): z.ZodObject<
	Properties<types.HcoAutocompleteResult>
> {
	return z.object({
		__typename: z.literal('HCOAutocompleteResult').optional(),
		hco: z.lazy(() => HcoSchema())
	});
}

export function HcoAutocompleteResultsSchema(): z.ZodObject<
	Properties<types.HcoAutocompleteResults>
> {
	return z.object({
		__typename: z.literal('HCOAutocompleteResults').optional(),
		results: z.array(z.lazy(() => HcoAutocompleteResultSchema()))
	});
}

export function HcoAutocompleteResultsBadRequestSchema() {
	return z.union([BadRequestSchema(), HcoAutocompleteResultsSchema()]);
}

export function HcoAutocompleteResultsForbiddenBadRequestSchema() {
	return z.union([
		BadRequestSchema(),
		ForbiddenSchema(),
		HcoAutocompleteResultsSchema()
	]);
}

export function HcohcpResourceNotFoundSchema() {
	return z.union([HcoSchema(), HcpSchema(), ResourceNotFoundSchema()]);
}

export function HcoHierarchyNodeSchema(): z.ZodObject<
	Properties<types.HcoHierarchyNode>
> {
	return z.object({
		__typename: z.literal('HCOHierarchyNode').optional(),
		displayName: z.string().nullish(),
		hcoTypeId: z.string().nullish(),
		hcoVid: z.string(),
		isMatch: z.boolean(),
		latitude: z.number().nullish(),
		longitude: z.number().nullish(),
		parentHcoVid: z.string().nullish(),
		searchMatches: z.array(z.lazy(() => TextMatchSchema()))
	});
}

export function HcoHierarchyResultSchema(): z.ZodObject<
	Properties<types.HcoHierarchyResult>
> {
	return z.object({
		__typename: z.literal('HCOHierarchyResult').optional(),
		facets: z.array(z.lazy(() => HcoTypeWithCountSchema())),
		nodes: z.array(z.lazy(() => HcoHierarchyNodeSchema()))
	});
}

export function HcoHierarchyResultBadRequestSchema() {
	return z.union([BadRequestSchema(), HcoHierarchyResultSchema()]);
}

export function HcoHierarchyTreeInputSchema(): z.ZodObject<
	Properties<types.HcoHierarchyTreeInput>
> {
	return z.object({
		hcoTypeIds: z.array(z.string()).nullish(),
		searchTerm: z.string().nullish()
	});
}

export function HcoHierarchyTypeSchema(): z.ZodObject<
	Properties<types.HcoHierarchyType>
> {
	return z.object({
		__typename: z.literal('HCOHierarchyType').optional(),
		code: z.string(),
		localizedName: z.string().nullish(),
		name: z.string()
	});
}

export function HcoInputSchema(): z.ZodObject<Properties<types.HcoInput>> {
	return z.object({
		vid: z.string()
	});
}

export function HcoOwnershipSchema(): z.ZodObject<
	Properties<types.HcoOwnership>
> {
	return z.object({
		__typename: z.literal('HCOOwnership').optional(),
		code: z.string(),
		localizedName: z.string().nullish(),
		name: z.string()
	});
}

export function HcoResourceNotFoundSchema() {
	return z.union([HcoSchema(), ResourceNotFoundSchema()]);
}

export function HcoSearchAndFiltersSchema(): z.ZodObject<
	Properties<types.HcoSearchAndFilters>
> {
	return z.object({
		__typename: z.literal('HCOSearchAndFilters').optional(),
		countries: z.array(z.lazy(() => CountrySchema())),
		inactiveCount: z.number().int(),
		recognizedEntities: z.lazy(() => RecognizedEntitiesHcoSchema()),
		search: z.lazy(() => HcoSearchResultsBadRequestSchema()),
		types: z.array(z.lazy(() => HcoTypeSchema()))
	});
}

export function HcoSearchAndFiltersSearchArgsSchema(): z.ZodObject<
	Properties<types.HcoSearchAndFiltersSearchArgs>
> {
	return z.object({
		paginationInput: z.lazy(() => PaginationInputSchema())
	});
}

export function HcoSearchAndFiltersBadRequestSchema() {
	return z.union([BadRequestSchema(), HcoSearchAndFiltersSchema()]);
}

export function HcoSearchAndFiltersInputSchema(): z.ZodObject<
	Properties<types.HcoSearchAndFiltersInput>
> {
	return z.object({
		countries: z.array(z.string()).nullish(),
		hcoTypes: z.array(z.string()).nullish(),
		includeInactive: z.boolean().default(false),
		pinnedEntities: z.lazy(() => PinnedEntitiesHcoInputSchema().nullish()),
		searchString: z.string().nullish(),
		states: z.array(z.string()).nullish()
	});
}

export function HcoSearchAndFiltersTypeSchema(): z.ZodObject<
	Properties<types.HcoSearchAndFiltersType>
> {
	return z.object({
		__typename: z.literal('HCOSearchAndFiltersType').optional(),
		countries: z.array(z.string()).nullish(),
		hcoTypes: z.array(z.string()).nullish(),
		includeInactive: z.boolean(),
		pinnedEntities: z.lazy(() => RecognizedEntitiesHcoSchema().nullish()),
		searchString: z.string().nullish(),
		states: z.array(z.string()).nullish()
	});
}

export function HcoSearchAndFiltersTypeHcpSearchAndFiltersTypeSchema() {
	return z.union([
		HcoSearchAndFiltersTypeSchema(),
		HcpSearchAndFiltersTypeSchema()
	]);
}

export function HcoSearchInputSchema(): z.ZodObject<
	Properties<types.HcoSearchInput>
> {
	return z.object({
		countries: z.array(z.string()).nullish(),
		hcoTypes: z.array(z.lazy(() => HcoTypeInputSchema())).nullish(),
		includeInactive: z.boolean().default(false),
		searchString: z.string().nullish(),
		states: z.array(z.string()).nullish()
	});
}

export function HcoSearchResultSchema(): z.ZodObject<
	Properties<types.HcoSearchResult>
> {
	return z.object({
		__typename: z.literal('HCOSearchResult').optional(),
		hco: z.lazy(() => HcoSchema())
	});
}

export function HcoSearchResultsSchema(): z.ZodObject<
	Properties<types.HcoSearchResults>
> {
	return z.object({
		__typename: z.literal('HCOSearchResults').optional(),
		_performance_timers: z.lazy(() => PerformanceTimersSchema()),
		pagination: z.lazy(() => PaginationMetadataSchema()),
		results: z.array(z.lazy(() => HcoSearchResultSchema()))
	});
}

export function HcoSearchResultsBadRequestSchema() {
	return z.union([BadRequestSchema(), HcoSearchResultsSchema()]);
}

export function HcoTypeSchema(): z.ZodObject<Properties<types.HcoType>> {
	return z.object({
		__typename: z.literal('HCOType').optional(),
		count: z.number().int(),
		id: z.string(),
		name: z.string()
	});
}

export function HcoTypeInputSchema(): z.ZodObject<
	Properties<types.HcoTypeInput>
> {
	return z.object({
		id: z.string()
	});
}

export function HcoTypeWithCountSchema(): z.ZodObject<
	Properties<types.HcoTypeWithCount>
> {
	return z.object({
		__typename: z.literal('HCOTypeWithCount').optional(),
		count: z.number().int(),
		hcoType: z.lazy(() => HcoTypeSchema())
	});
}

export function HcOsInputSchema(): z.ZodObject<Properties<types.HcOsInput>> {
	return z.object({
		vids: z.array(z.string())
	});
}

export function HcpSchema(): z.ZodObject<Properties<types.Hcp>> {
	return z.object({
		__typename: z.literal('HCP').optional(),
		URL1_V: z.string().nullish(),
		addresses: z.array(z.lazy(() => AddressSchema())),
		affiliatedHcoTypes: z.array(z.lazy(() => HcoTypeSchema())),
		affiliationInHco: z.lazy(() => ParentHcoSchema().nullish()),
		affiliationSearch: z.lazy(() => HcpAffiliationsResultsBadRequestSchema()),
		affiliations: z.lazy(() => HcpAffiliationsResultsSchema()),
		affiliationsInSelectedHcos: z.array(z.lazy(() => ParentHcoSchema())),
		allDegreeCda_V: z.string().nullish(),
		birthYear_V: z.number().int().nullish(),
		countryId: z.string().nullish(),
		dataPrivacyOptOut_V: z.boolean().nullish(),
		degree1Cda_V: z.string().nullish(),
		email: z.lazy(() => EmailValueForbiddenSchema().nullish()),
		email2: z.lazy(() => EmailValueForbiddenSchema().nullish()),
		email3: z.lazy(() => EmailValueForbiddenSchema().nullish()),
		email4: z.lazy(() => EmailValueForbiddenSchema().nullish()),
		email5: z.lazy(() => EmailValueForbiddenSchema().nullish()),
		emailCda_V: z.string().nullish(),
		emailCount: z.number().int(),
		faxCda_V: z.string().nullish(),
		firstNameCda_V: z.string().nullish(),
		firstNameIntl_V: z.string().nullish(),
		gender_V: z.string().nullish(),
		gradSchool_V: z.string().nullish(),
		gradYear_V: z.number().int().nullish(),
		hcpReasonStatus: z.lazy(() => HcpReasonStatusSchema().nullish()),
		hcpSpecialties: z.array(z.lazy(() => HcpSpecialtySchema())),
		hcpStatus_V: z.string().nullish(),
		hcpTaxId_V: z.string().nullish(),
		hcpType: z.lazy(() => HcpTypeSchema().nullish()),
		hcpTypeCdaId: z.string().nullish(),
		hcpTypeCda_V: z.string().nullish(),
		inCurrentPecos_V: z.boolean().nullish(),
		inactiveAffiliationCount: z.number().int(),
		internationalNameCda_V: z.string().nullish(),
		internationalName_V: z.string().nullish(),
		kaiser_V: z.boolean().nullish(),
		languageCda_V: z.string().nullish(),
		lastNameCda_V: z.string().nullish(),
		lastNameIntl_V: z.string().nullish(),
		licenses: z.array(z.lazy(() => LicenseSchema())),
		localHcpType: z.lazy(() => LocalHcpTypeSchema().nullish()),
		localSpecialties: z.array(z.lazy(() => LocalSpecialtySchema())),
		mainOrganization: z.lazy(() => HcoResourceNotFoundSchema().nullish()),
		middleNameCda_V: z.string().nullish(),
		middleNameIntl_V: z.string().nullish(),
		nhid2_V: z.string().nullish(),
		nhidCda_V: z.string().nullish(),
		nickname_V: z.string().nullish(),
		officePhoneCda_V: z.string().nullish(),
		parenthcos: z.array(z.lazy(() => ParentHcoSchema())),
		phone2_V: z.string().nullish(),
		prefixCda_V: z.string().nullish(),
		prescriberCda_V: z.boolean().nullish(),
		primaryAffiliation: z.lazy(() => HcoResourceNotFoundSchema().nullish()),
		primaryLocalSpecialty: z.lazy(() => LocalSpecialtySchema().nullish()),
		secondaryLocalSpecialty: z.lazy(() => LocalSpecialtySchema().nullish()),
		specialties: z.array(z.lazy(() => SpecialtySchema())),
		specialty1_V: z.string().nullish(),
		specialty2_V: z.string().nullish(),
		specialty3_V: z.string().nullish(),
		specialty4_V: z.string().nullish(),
		specialty5_V: z.string().nullish(),
		specialty6_V: z.string().nullish(),
		specialty7_V: z.string().nullish(),
		specialty8_V: z.string().nullish(),
		specialty9_V: z.string().nullish(),
		specialty10_V: z.string().nullish(),
		statusCda_V: z.string().nullish(),
		statusCda_VId: z.string().nullish(),
		suffixCda_V: z.string().nullish(),
		telehealth_V: z.boolean().nullish(),
		topOrganization: z.lazy(() => HcoResourceNotFoundSchema().nullish()),
		veevaid_V: z.string(),
		vid_V: z.string(),
		websiteCda_V: z.string().nullish(),
		yearOfBirthCda_V: z.number().int().nullish()
	});
}

export function HcpAddressesArgsSchema(): z.ZodObject<
	Properties<types.HcpAddressesArgs>
> {
	return z.object({
		includeInactive: z.boolean().default(false)
	});
}

export function HcpAffiliationInHcoArgsSchema(): z.ZodObject<
	Properties<types.HcpAffiliationInHcoArgs>
> {
	return z.object({
		hcoVid: z.string(),
		includeInactive: z.boolean().default(false)
	});
}

export function HcpAffiliationSearchArgsSchema(): z.ZodObject<
	Properties<types.HcpAffiliationSearchArgs>
> {
	return z.object({
		paginationInput: z.lazy(() => PaginationInputSchema()),
		payload: z.lazy(() => HcpAffiliationSearchInputSchema())
	});
}

export function HcpAffiliationsArgsSchema(): z.ZodObject<
	Properties<types.HcpAffiliationsArgs>
> {
	return z.object({
		paginationInput: z.lazy(() => PaginationInputSchema()),
		payload: z.lazy(() => HcpAffiliationsInputSchema())
	});
}

export function HcpAffiliationsInSelectedHcosArgsSchema(): z.ZodObject<
	Properties<types.HcpAffiliationsInSelectedHcosArgs>
> {
	return z.object({
		hcoIds: z.array(z.string()),
		includeInactive: z.boolean().default(false)
	});
}

export function HcpAllDegreeCda_VArgsSchema(): z.ZodObject<
	Properties<types.HcpAllDegreeCda_VArgs>
> {
	return z.object({
		includePrimary: z.boolean().default(false)
	});
}

export function HcpAffiliationSearchInputSchema(): z.ZodObject<
	Properties<types.HcpAffiliationSearchInput>
> {
	return z.object({
		includeInactive: z.boolean().nullish(),
		nameSearch: z.string().nullish()
	});
}

export function HcpAffiliationsInputSchema(): z.ZodObject<
	Properties<types.HcpAffiliationsInput>
> {
	return z.object({
		includeInactive: z.boolean().nullish()
	});
}

export function HcpAffiliationsResultsSchema(): z.ZodObject<
	Properties<types.HcpAffiliationsResults>
> {
	return z.object({
		__typename: z.literal('HCPAffiliationsResults').optional(),
		hcoTypes: z.array(z.lazy(() => HcoTypeWithCountSchema())),
		inactiveCount: z.number().int(),
		paginationMetadata: z.lazy(() => PaginationMetadataSchema()),
		results: z.array(z.lazy(() => ParentHcoSchema()))
	});
}

export function HcpAffiliationsResultsBadRequestSchema() {
	return z.union([BadRequestSchema(), HcpAffiliationsResultsSchema()]);
}

export function HcphcoSchema() {
	return z.union([HcoSchema(), HcpSchema()]);
}

export function HcpInputSchema(): z.ZodObject<Properties<types.HcpInput>> {
	return z.object({
		vid: z.string()
	});
}

export function HcpReasonStatusSchema(): z.ZodObject<
	Properties<types.HcpReasonStatus>
> {
	return z.object({
		__typename: z.literal('HCPReasonStatus').optional(),
		code: z.string(),
		localizedName: z.string().nullish(),
		name: z.string()
	});
}

export function HcpResourceNotFoundSchema() {
	return z.union([HcpSchema(), ResourceNotFoundSchema()]);
}

export function HcpSearchAndFiltersSchema(): z.ZodObject<
	Properties<types.HcpSearchAndFilters>
> {
	return z.object({
		__typename: z.literal('HCPSearchAndFilters').optional(),
		countries: z.array(z.lazy(() => CountrySchema())),
		hcoFilterOptionSearch: z.lazy(() =>
			HcoFilterOptionSearchResultsBadRequestSchema()
		),
		hcoTypes: z.array(z.lazy(() => HcoTypeSchema())),
		inactiveCount: z.number().int(),
		recognizedEntities: z.lazy(() => RecognizedEntitiesHcpSchema()),
		search: z.lazy(() => HcpSearchResultsBadRequestSchema()),
		specialtyGroups: z.array(z.lazy(() => SpecialtyGroupSchema())),
		types: z.array(z.lazy(() => HcpTypeSchema()))
	});
}

export function HcpSearchAndFiltersHcoFilterOptionSearchArgsSchema(): z.ZodObject<
	Properties<types.HcpSearchAndFiltersHcoFilterOptionSearchArgs>
> {
	return z.object({
		payload: z.lazy(() => HcoFilterOptionSearchInputSchema())
	});
}

export function HcpSearchAndFiltersSearchArgsSchema(): z.ZodObject<
	Properties<types.HcpSearchAndFiltersSearchArgs>
> {
	return z.object({
		paginationInput: z.lazy(() => PaginationInputSchema())
	});
}

export function HcpSearchAndFiltersBadRequestSchema() {
	return z.union([BadRequestSchema(), HcpSearchAndFiltersSchema()]);
}

export function HcpSearchAndFiltersInputSchema(): z.ZodObject<
	Properties<types.HcpSearchAndFiltersInput>
> {
	return z.object({
		countries: z.array(z.string()).nullish(),
		hcoTypes: z.array(z.string()).nullish(),
		hcos: z.array(z.string()).nullish(),
		hcpTypes: z.array(z.string()).nullish(),
		includeInactive: z.boolean().default(false),
		pinnedEntities: z.lazy(() => PinnedEntitiesHcpInputSchema().nullish()),
		searchString: z.string().nullish(),
		specialties: z.array(z.string()).nullish(),
		specialtyGroups: z.array(z.string()).nullish(),
		states: z.array(z.string()).nullish()
	});
}

export function HcpSearchAndFiltersTypeSchema(): z.ZodObject<
	Properties<types.HcpSearchAndFiltersType>
> {
	return z.object({
		__typename: z.literal('HCPSearchAndFiltersType').optional(),
		countries: z.array(z.string()).nullish(),
		hcoTypes: z.array(z.string()).nullish(),
		hcos: z.array(z.string()).nullish(),
		hcpTypes: z.array(z.string()).nullish(),
		includeInactive: z.boolean(),
		pinnedEntities: z.lazy(() => RecognizedEntitiesHcpSchema().nullish()),
		searchString: z.string().nullish(),
		specialties: z.array(z.string()).nullish(),
		specialtyGroups: z.array(z.string()).nullish(),
		states: z.array(z.string()).nullish()
	});
}

export function HcpSearchInputSchema(): z.ZodObject<
	Properties<types.HcpSearchInput>
> {
	return z.object({
		countries: z.array(z.string()).nullish(),
		hcoTypes: z.array(z.string()).nullish(),
		hcos: z.array(z.string()).nullish(),
		hcpTypes: z.array(z.string()).nullish(),
		includeInactive: z.boolean().default(false),
		searchString: z.string().nullish(),
		specialties: z.array(z.string()).nullish(),
		specialtyGroups: z.array(z.string()).nullish(),
		states: z.array(z.string()).nullish()
	});
}

export function HcpSearchResultSchema(): z.ZodObject<
	Properties<types.HcpSearchResult>
> {
	return z.object({
		__typename: z.literal('HCPSearchResult').optional(),
		hcp: z.lazy(() => HcpSchema())
	});
}

export function HcpSearchResultsSchema(): z.ZodObject<
	Properties<types.HcpSearchResults>
> {
	return z.object({
		__typename: z.literal('HCPSearchResults').optional(),
		_performance_timers: z.lazy(() => PerformanceTimersSchema()),
		pagination: z.lazy(() => PaginationMetadataSchema()),
		results: z.array(z.lazy(() => HcpSearchResultSchema()))
	});
}

export function HcpSearchResultsBadRequestSchema() {
	return z.union([BadRequestSchema(), HcpSearchResultsSchema()]);
}

export function HcpSpecialtySchema(): z.ZodObject<
	Properties<types.HcpSpecialty>
> {
	return z.object({
		__typename: z.literal('HCPSpecialty').optional(),
		primary: z.boolean(),
		specialty: z.lazy(() => SpecialtySchema())
	});
}

export function HcpTypeSchema(): z.ZodObject<Properties<types.HcpType>> {
	return z.object({
		__typename: z.literal('HCPType').optional(),
		count: z.number().int(),
		id: z.string(),
		name: z.string()
	});
}

export function HcpTypeWithCountSchema(): z.ZodObject<
	Properties<types.HcpTypeWithCount>
> {
	return z.object({
		__typename: z.literal('HCPTypeWithCount').optional(),
		count: z.number().int(),
		hcpType: z.lazy(() => HcpTypeSchema())
	});
}

export function HcPsInputSchema(): z.ZodObject<Properties<types.HcPsInput>> {
	return z.object({
		vids: z.array(z.string())
	});
}

export function HcoFilterOptionSchema(): z.ZodObject<
	Properties<types.HcoFilterOption>
> {
	return z.object({
		__typename: z.literal('HcoFilterOption').optional(),
		affiliatedHcpCount: z.number().int(),
		hco: z.lazy(() => HcoSchema())
	});
}

export function HcoFilterOptionSearchInputSchema(): z.ZodObject<
	Properties<types.HcoFilterOptionSearchInput>
> {
	return z.object({
		limit: z.number().int().default(7),
		recentSelectedLimit: z.number().int().default(0),
		searchString: z.string().nullish()
	});
}

export function HcoFilterOptionSearchResultsSchema(): z.ZodObject<
	Properties<types.HcoFilterOptionSearchResults>
> {
	return z.object({
		__typename: z.literal('HcoFilterOptionSearchResults').optional(),
		results: z.array(z.lazy(() => HcoFilterOptionSchema()))
	});
}

export function HcoFilterOptionSearchResultsBadRequestSchema() {
	return z.union([BadRequestSchema(), HcoFilterOptionSearchResultsSchema()]);
}

export function InitiateAuthInputSchema(): z.ZodObject<
	Properties<types.InitiateAuthInput>
> {
	return z.object({
		username: z.string()
	});
}

export function InitiateAuthResultSchema(): z.ZodObject<
	Properties<types.InitiateAuthResult>
> {
	return z.object({
		__typename: z.literal('InitiateAuthResult').optional(),
		challenge: AuthenticationChallengeSchema
	});
}

export function LicenseSchema(): z.ZodObject<Properties<types.License>> {
	return z.object({
		__typename: z.literal('License').optional(),
		address: z.lazy(() => AddressSchema().nullish()),
		bestStateLicense_V: z.boolean().nullish(),
		body_V: z.string().nullish(),
		collabAgreeRequired_V: z.string().nullish(),
		comprehensivePrescriptiveAuthority_V: z.string().nullish(),
		comprehensiveSampleEligibility_V: z.string().nullish(),
		ctrlSubstancePrescriptive_V: z.string().nullish(),
		ctrlSubstanceSample_V: z.string().nullish(),
		deaBusinessActivityCode_V: z.string().nullish(),
		deaPaymentIndicator_V: z.string().nullish(),
		drugSchedule_V: z.string().nullish(),
		expirationDate_V: z.string().nullish(),
		gracePeriod_V: z.string().nullish(),
		licenseCertification_V: z.string().nullish(),
		licenseDegree_V: z.string().nullish(),
		licenseEligibility_V: z.string().nullish(),
		licenseNumber_V: z.string().nullish(),
		licenseStatusCondition_V: z.string().nullish(),
		licenseStatus_V: z.string().nullish(),
		licenseSubtype_V: z.string().nullish(),
		licensingBody_V: z.string().nullish(),
		rxaEligible_V: z.string().nullish(),
		sourceAddress_V: z.string().nullish(),
		typeValue_VId: z.string().nullish(),
		type_V: z.string().nullish(),
		vid_V: z.string()
	});
}

export function LocalHcoTypeSchema(): z.ZodObject<
	Properties<types.LocalHcoType>
> {
	return z.object({
		__typename: z.literal('LocalHCOType').optional(),
		code: z.string(),
		localizedName: z.string().nullish(),
		name: z.string()
	});
}

export function LocalHcpTypeSchema(): z.ZodObject<
	Properties<types.LocalHcpType>
> {
	return z.object({
		__typename: z.literal('LocalHCPType').optional(),
		code: z.string(),
		localizedName: z.string().nullish(),
		name: z.string()
	});
}

export function LocalSpecialtySchema(): z.ZodObject<
	Properties<types.LocalSpecialty>
> {
	return z.object({
		__typename: z.literal('LocalSpecialty').optional(),
		code: z.string(),
		localizedName: z.string().nullish(),
		name: z.string()
	});
}

export function NoContentSchema(): z.ZodObject<Properties<types.NoContent>> {
	return z.object({
		__typename: z.literal('NoContent').optional(),
		message: z.string()
	});
}

export function NoContentForbiddenResourceNotFoundSchema() {
	return z.union([
		ForbiddenSchema(),
		NoContentSchema(),
		ResourceNotFoundSchema()
	]);
}

export function PaginationInputSchema(): z.ZodObject<
	Properties<types.PaginationInput>
> {
	return z.object({
		page: z.number().int().default(1),
		pageSize: z.number().int().default(20)
	});
}

export function PaginationMetadataSchema(): z.ZodObject<
	Properties<types.PaginationMetadata>
> {
	return z.object({
		__typename: z.literal('PaginationMetadata').optional(),
		page: z.number().int(),
		pageSize: z.number().int(),
		total: z.number().int(),
		totalPages: z.number().int()
	});
}

export function ParentHcoSchema(): z.ZodObject<Properties<types.ParentHco>> {
	return z.object({
		__typename: z.literal('ParentHCO').optional(),
		childHco: z.lazy(() => HcoResourceNotFoundSchema()),
		childVeevaid_V: z.string().nullish(),
		classOfWork_V: z.string().nullish(),
		hcp: z.lazy(() => HcpResourceNotFoundSchema()),
		isPrimaryRelationship_V: z.boolean().nullish(),
		jobTitle_V: z.string().nullish(),
		parentHco: z.lazy(() => HcoResourceNotFoundSchema()),
		parentHcoStatus_VId: z.string().nullish(),
		parentVeevaid_V: z.string().nullish(),
		relationshipType: z.lazy(() => RelationshipTypeSchema().nullish()),
		relationshipType_V: z.string().nullish(),
		role_V: z.string().nullish(),
		vid_V: z.string()
	});
}

export function PatchUserInputSchema(): z.ZodObject<
	Properties<types.PatchUserInput>
> {
	return z.object({
		baseCountryId: z.string().nullish(),
		countryPreferences: z.array(z.string()).nullish(),
		department: DepartmentSchema.nullish(),
		role: RoleSchema.nullish()
	});
}

export function PerformanceTimersSchema(): z.ZodObject<
	Properties<types.PerformanceTimers>
> {
	return z.object({
		__typename: z.literal('PerformanceTimers').optional(),
		entityResolution: z.number().int().nullish(),
		namedEntityRecognition: z.number().int().nullish(),
		searchCluster: z.number().int().nullish()
	});
}

export function PinnedEntitiesHcoInputSchema(): z.ZodObject<
	Properties<types.PinnedEntitiesHcoInput>
> {
	return z.object({
		cityNames: z.array(z.string()),
		countryIds: z.array(z.string()),
		countyNames: z.array(z.string()),
		hasLocationContext: z.boolean().nullish(),
		hcoNames: z.array(z.string()),
		localTypeIds: z.array(z.string()),
		specialties: z.array(z.lazy(() => PinnedSpecialtyInputSchema())),
		stateIds: z.array(z.string()),
		streetAddresses: z.array(z.string()),
		typeIds: z.array(z.string())
	});
}

export function PinnedEntitiesHcpInputSchema(): z.ZodObject<
	Properties<types.PinnedEntitiesHcpInput>
> {
	return z.object({
		cityNames: z.array(z.string()),
		countryIds: z.array(z.string()),
		countyNames: z.array(z.string()),
		hasLocationContext: z.boolean().nullish(),
		hcoNames: z.array(z.string()),
		localTypeIds: z.array(z.string()),
		personNames: z.array(z.string()),
		specialties: z.array(z.lazy(() => PinnedSpecialtyInputSchema())),
		specialtyGroupIds: z.array(z.string()),
		specialtyIds: z.array(z.string()),
		stateIds: z.array(z.string()),
		streetAddresses: z.array(z.string()),
		titleGroups: z.array(z.string()),
		typeIds: z.array(z.string())
	});
}

export function PinnedSpecialtyInputSchema(): z.ZodObject<
	Properties<types.PinnedSpecialtyInput>
> {
	return z.object({
		localSpecialtyIds: z.array(z.string()),
		originalTerm: z.string().nullish(),
		term: z.string().nullish()
	});
}

export function ProfileVisitSchema(): z.ZodObject<
	Properties<types.ProfileVisit>
> {
	return z.object({
		__typename: z.literal('ProfileVisit').optional(),
		lastVisit: z.string().datetime(),
		profile: z.lazy(() => HcohcpResourceNotFoundSchema())
	});
}

export function ProfileVisitResourceNotFoundSchema() {
	return z.union([ProfileVisitSchema(), ResourceNotFoundSchema()]);
}

export function ProfileVisitResultsSchema(): z.ZodObject<
	Properties<types.ProfileVisitResults>
> {
	return z.object({
		__typename: z.literal('ProfileVisitResults').optional(),
		pagination: z.lazy(() => PaginationMetadataSchema()),
		results: z.array(z.lazy(() => ProfileVisitSchema()))
	});
}

export function ProfileVisitResultsBadRequestSchema() {
	return z.union([BadRequestSchema(), ProfileVisitResultsSchema()]);
}

export function RecentHcoFilterSelectionSchema(): z.ZodObject<
	Properties<types.RecentHcoFilterSelection>
> {
	return z.object({
		__typename: z.literal('RecentHcoFilterSelection').optional(),
		hcoVid: z.string(),
		selectedAt: z.string().datetime()
	});
}

export function RecentHcoFilterSelectionResourceNotFoundSchema() {
	return z.union([RecentHcoFilterSelectionSchema(), ResourceNotFoundSchema()]);
}

export function RecentSearchSchema(): z.ZodObject<
	Properties<types.RecentSearch>
> {
	return z.object({
		__typename: z.literal('RecentSearch').optional(),
		entityType: EntityTypeSchema,
		lastSearch: z.string().datetime(),
		payload: z.lazy(() =>
			HcoSearchAndFiltersTypeHcpSearchAndFiltersTypeSchema()
		),
		searchKey: z.string()
	});
}

export function RecentSearchBadRequestSchema() {
	return z.union([BadRequestSchema(), RecentSearchSchema()]);
}

export function RecentSearchInputSchema(): z.ZodObject<
	Properties<types.RecentSearchInput>
> {
	return z.object({
		queryString: z.string(),
		search: z.lazy(() => EitherSearchInputSchema()),
		searchKey: z.string().nullish()
	});
}

export function RecentSearchResultsSchema(): z.ZodObject<
	Properties<types.RecentSearchResults>
> {
	return z.object({
		__typename: z.literal('RecentSearchResults').optional(),
		pagination: z.lazy(() => PaginationMetadataSchema()),
		results: z.array(z.lazy(() => RecentSearchSchema()))
	});
}

export function RecentSearchResultsBadRequestSchema() {
	return z.union([BadRequestSchema(), RecentSearchResultsSchema()]);
}

export function RecognizedEntitiesHcoSchema(): z.ZodObject<
	Properties<types.RecognizedEntitiesHco>
> {
	return z.object({
		__typename: z.literal('RecognizedEntitiesHCO').optional(),
		cityNames: z.array(z.string()),
		countries: z.array(z.lazy(() => CountrySchema())),
		countryIds: z.array(z.string()),
		countyNames: z.array(z.string()),
		hasLocationContext: z.boolean(),
		hcoNames: z.array(z.string()),
		localSpecialties: z.array(z.lazy(() => LocalSpecialtySchema())),
		localTypeIds: z.array(z.string()),
		localTypes: z.array(z.lazy(() => LocalHcoTypeSchema())),
		specialties: z.array(z.lazy(() => RecognizedSpecialtySchema())),
		stateIds: z.array(z.string()),
		states: z.array(z.lazy(() => StateSchema())),
		streetAddresses: z.array(z.string()),
		typeIds: z.array(z.string()),
		types: z.array(z.lazy(() => HcoTypeSchema()))
	});
}

export function RecognizedEntitiesHcpSchema(): z.ZodObject<
	Properties<types.RecognizedEntitiesHcp>
> {
	return z.object({
		__typename: z.literal('RecognizedEntitiesHCP').optional(),
		cityNames: z.array(z.string()),
		countries: z.array(z.lazy(() => CountrySchema())),
		countryIds: z.array(z.string()),
		countyNames: z.array(z.string()),
		globalSpecialties: z.array(z.lazy(() => SpecialtySchema())),
		hasLocationContext: z.boolean(),
		hcoNames: z.array(z.string()),
		localSpecialties: z.array(z.lazy(() => LocalSpecialtySchema())),
		localTypeIds: z.array(z.string()),
		localTypes: z.array(z.lazy(() => LocalHcpTypeSchema())),
		personNames: z.array(z.string()),
		specialties: z.array(z.lazy(() => RecognizedSpecialtySchema())),
		specialtyGroupIds: z.array(z.string()),
		specialtyGroups: z.array(z.lazy(() => SpecialtyGroupSchema())),
		specialtyIds: z.array(z.string()),
		stateIds: z.array(z.string()),
		states: z.array(z.lazy(() => StateSchema())),
		streetAddresses: z.array(z.string()),
		titleGroups: z.array(z.string()),
		typeIds: z.array(z.string()),
		types: z.array(z.lazy(() => HcpTypeSchema()))
	});
}

export function RecognizedSpecialtySchema(): z.ZodObject<
	Properties<types.RecognizedSpecialty>
> {
	return z.object({
		__typename: z.literal('RecognizedSpecialty').optional(),
		localSpecialtyIds: z.array(z.string()),
		originalTerm: z.string().nullish(),
		term: z.string()
	});
}

export function ReferenceSchema(): z.ZodObject<Properties<types.Reference>> {
	return z.object({
		__typename: z.literal('Reference').optional(),
		code: z.string(),
		localizedName: z.string().nullish(),
		name: z.string()
	});
}

export function ReferenceInputSchema(): z.ZodObject<
	Properties<types.ReferenceInput>
> {
	return z.object({
		countryId: z.string().nullish(),
		referenceType: ReferenceTypeSchema
	});
}

export function ReferenceResultSchema(): z.ZodObject<
	Properties<types.ReferenceResult>
> {
	return z.object({
		__typename: z.literal('ReferenceResult').optional(),
		results: z.array(z.lazy(() => ReferenceSchema()))
	});
}

export function ReferenceResultBadRequestSchema() {
	return z.union([BadRequestSchema(), ReferenceResultSchema()]);
}

export function RelationshipTypeSchema(): z.ZodObject<
	Properties<types.RelationshipType>
> {
	return z.object({
		__typename: z.literal('RelationshipType').optional(),
		code: z.string(),
		localizedName: z.string().nullish(),
		name: z.string()
	});
}

export function ResourceNotFoundSchema(): z.ZodObject<
	Properties<types.ResourceNotFound>
> {
	return z.object({
		__typename: z.literal('ResourceNotFound').optional(),
		message: z.string()
	});
}

export function SearchAsYouTypeInputSchema(): z.ZodObject<
	Properties<types.SearchAsYouTypeInput>
> {
	return z.object({
		searchString: z.string(),
		size: z.number().int().default(6)
	});
}

export function SearchAsYouTypePerformanceTimersSchema(): z.ZodObject<
	Properties<types.SearchAsYouTypePerformanceTimers>
> {
	return z.object({
		__typename: z.literal('SearchAsYouTypePerformanceTimers').optional(),
		entityResolution: z.number().int().nullish(),
		namedEntityRecognitionCluster: z.number().int().nullish(),
		namedEntityRecognitionFull: z.number().int().nullish(),
		searchCluster: z.number().int().nullish()
	});
}

export function SearchAsYouTypeResultSchema(): z.ZodObject<
	Properties<types.SearchAsYouTypeResult>
> {
	return z.object({
		__typename: z.literal('SearchAsYouTypeResult').optional(),
		entity: z.lazy(() => HcphcoSchema()),
		score: z.number()
	});
}

export function SearchAsYouTypeResultsSchema(): z.ZodObject<
	Properties<types.SearchAsYouTypeResults>
> {
	return z.object({
		__typename: z.literal('SearchAsYouTypeResults').optional(),
		_performance_timers: z.lazy(() => SearchAsYouTypePerformanceTimersSchema()),
		results: z.array(z.lazy(() => SearchAsYouTypeResultSchema()))
	});
}

export function SearchAsYouTypeResultsBadRequestSchema() {
	return z.union([BadRequestSchema(), SearchAsYouTypeResultsSchema()]);
}

export function SearchDownloadLinkSchema(): z.ZodObject<
	Properties<types.SearchDownloadLink>
> {
	return z.object({
		__typename: z.literal('SearchDownloadLink').optional(),
		downloadUrl: z.string(),
		filename: z.string(),
		gdprRemovedRows: z.number().int(),
		gdprRows: z.number().int(),
		totalRows: z.number().int()
	});
}

export function SearchDownloadLinkForbiddenBadRequestSchema() {
	return z.union([
		BadRequestSchema(),
		ForbiddenSchema(),
		SearchDownloadLinkSchema()
	]);
}

export function SearchMyDcRsInputSchema(): z.ZodObject<
	Properties<types.SearchMyDcRsInput>
> {
	return z.object({
		searchString: z.string().nullish(),
		statuses: z.array(DcrDisplayStatusSchema).nullish(),
		type: DcrTypeSchema.nullish()
	});
}

export function ServiceUnavailableSchema(): z.ZodObject<
	Properties<types.ServiceUnavailable>
> {
	return z.object({
		__typename: z.literal('ServiceUnavailable').optional(),
		message: z.string()
	});
}

export function SignInInputSchema(): z.ZodObject<
	Properties<types.SignInInput>
> {
	return z.object({
		magicLinkToken: z.string().nullish(),
		password: z.string().nullish(),
		username: z.string().nullish()
	});
}

export function SignInResultSchema(): z.ZodObject<
	Properties<types.SignInResult>
> {
	return z.object({
		__typename: z.literal('SignInResult').optional(),
		expiresIn: z.number().int(),
		idToken: z.string()
	});
}

export function SignOutResultSchema(): z.ZodObject<
	Properties<types.SignOutResult>
> {
	return z.object({
		__typename: z.literal('SignOutResult').optional(),
		message: z.string(),
		success: z.boolean()
	});
}

export function SpecialtySchema(): z.ZodObject<Properties<types.Specialty>> {
	return z.object({
		__typename: z.literal('Specialty').optional(),
		count: z.number().int().nullish(),
		id: z.string(),
		name: z.string(),
		specialtyGroup: z.lazy(() => SpecialtyGroupSchema())
	});
}

export function SpecialtyGroupSchema(): z.ZodObject<
	Properties<types.SpecialtyGroup>
> {
	return z.object({
		__typename: z.literal('SpecialtyGroup').optional(),
		count: z.number().int().nullish(),
		id: z.string(),
		name: z.string(),
		specialties: z.array(z.lazy(() => SpecialtySchema()))
	});
}

export function SpecialtyWithCountSchema(): z.ZodObject<
	Properties<types.SpecialtyWithCount>
> {
	return z.object({
		__typename: z.literal('SpecialtyWithCount').optional(),
		count: z.number().int(),
		specialty: z.lazy(() => SpecialtySchema())
	});
}

export function StateSchema(): z.ZodObject<Properties<types.State>> {
	return z.object({
		__typename: z.literal('State').optional(),
		count: z.number().int(),
		id: z.string(),
		name: z.string()
	});
}

export function SuggestedDcrFieldsSchema(): z.ZodObject<
	Properties<types.SuggestedDcrFields>
> {
	return z.object({
		__typename: z.literal('SuggestedDCRFields').optional(),
		results: z.array(z.string())
	});
}

export function SuggestedDcrFieldsForbiddenBadRequestSchema() {
	return z.union([
		BadRequestSchema(),
		ForbiddenSchema(),
		SuggestedDcrFieldsSchema()
	]);
}

export function SuggestedDcrFieldsInputSchema(): z.ZodObject<
	Properties<types.SuggestedDcrFieldsInput>
> {
	return z.object({
		entityType: EntityTypeSchema,
		fieldsToIgnore: z.array(DcrFieldNameSchema),
		limit: z.number().int()
	});
}

export function TextMatchSchema(): z.ZodObject<Properties<types.TextMatch>> {
	return z.object({
		__typename: z.literal('TextMatch').optional(),
		endIndex: z.number().int(),
		startIndex: z.number().int()
	});
}

export function TrackEntityProfileViewInputSchema(): z.ZodObject<
	Properties<types.TrackEntityProfileViewInput>
> {
	return z.object({
		veevaId: z.string()
	});
}

export function TrackPageViewInputSchema(): z.ZodObject<
	Properties<types.TrackPageViewInput>
> {
	return z.object({
		pagePath: z.string()
	});
}

export function TrackSearchInputSchema(): z.ZodObject<
	Properties<types.TrackSearchInput>
> {
	return z.object({
		entityType: EntityTypeSchema,
		queryString: z.string(),
		resultsCount: z.number().int()
	});
}

export function UnavailableFieldsSchema(): z.ZodObject<
	Properties<types.UnavailableFields>
> {
	return z.object({
		__typename: z.literal('UnavailableFields').optional(),
		results: z.array(z.string())
	});
}

export function UnavailableFieldsForbiddenBadRequestSchema() {
	return z.union([
		BadRequestSchema(),
		ForbiddenSchema(),
		UnavailableFieldsSchema()
	]);
}

export function UpdateRecentProfilesInputSchema(): z.ZodObject<
	Properties<types.UpdateRecentProfilesInput>
> {
	return z.object({
		veevaId: z.string()
	});
}

export function UserSchema(): z.ZodObject<Properties<types.User>> {
	return z.object({
		__typename: z.literal('User').optional(),
		baseCountry: z.lazy(() => CountrySchema().nullish()),
		countryPreferences: z.array(z.lazy(() => CountrySchema())),
		dcrEnabled: z.boolean(),
		department: DepartmentSchema.nullish(),
		email: z.string(),
		id: z.string().uuid(),
		licensedCountries: z.array(z.lazy(() => CountrySchema())),
		permissions: z.array(z.string()),
		requiresOnboardingPrompt: z.boolean(),
		role: RoleSchema.nullish()
	});
}

export function UserBadRequestForbiddenSchema() {
	return z.union([BadRequestSchema(), ForbiddenSchema(), UserSchema()]);
}
